import { Form } from '@unform/web';
import styled from 'styled-components';

export const WrapperForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .MuiGrid-spacing-xs-2 {
    width: 100% !important;
  }

  > div:not(:first-child) {
    margin-top: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;
